import { Component, Input, OnInit } from '@angular/core';
import {
  DivisionalPromotionFilterType,
  DivisionalPromotionFilterValues,
} from '@app/seller-showcase/models/seller-showcase.model';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';

@Component({
  template: '',
})
export class SellerShowcaseFiltersBaseComponent implements OnInit {
  @Input() brandsNames: string[];
  @Input() promoTypes: string[];
  @Input() exclusiveBrandValues: string[];
  @Input() productClasses: string[];
  @Input() selectedFilters: Map<DivisionalPromotionFilterType, string>;

  filterTypes = DivisionalPromotionFilterType;
  filterValues = DivisionalPromotionFilterValues;
  selectedFilter: DivisionalPromotionFilterType;

  selectedBrand: string = null;
  selectedPromoType: string = null;
  selectedExclusiveBrand: string = null;
  selectedProductClass: string = null;

  constructor(
    readonly platformService: PlatformService,
    private modalController: ModalController,
  ) {}

  ngOnInit() {
    this.setDefaultValues();
  }

  setDefaultValues() {
    if (
      this.platformService.platformType !==
      this.platformService.platformEnum.mobile
    ) {
      this.selectedFilter = DivisionalPromotionFilterType.brand;
    }
    this.selectedBrand = this.selectedFilters?.get(
      DivisionalPromotionFilterType.brand,
    );
    this.selectedPromoType = this.selectedFilters?.get(
      DivisionalPromotionFilterType.promoType,
    );
    this.selectedExclusiveBrand = this.selectedFilters?.get(
      DivisionalPromotionFilterType.exclusiveBrand,
    );
    this.selectedProductClass = this.selectedFilters?.get(
      DivisionalPromotionFilterType.productClass,
    );
  }

  setFilter(filter: DivisionalPromotionFilterType) {
    this.selectedFilter = filter;
  }

  selectValue(event: any) {
    const newFilters = new Map(this.selectedFilters);
    newFilters.set(this.selectedFilter, event.detail.value);
    this.selectedFilters = newFilters;
  }

  async applyAll() {
    await this.modalController.dismiss({
      appliedFilters: this.selectedFilters,
    });
  }

  clearAll() {
    this.selectedFilters = new Map();
    this.selectedBrand = null;
    this.selectedPromoType = null;
    this.selectedExclusiveBrand = null;
    this.selectedProductClass = null;
  }

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
